export default function toggleStaticMainContentElements(display: boolean) {
    const mainContent = document.getElementById('main-content');
    if (mainContent) {
        if (display) {
            mainContent.classList.remove('hide')
        } else {
            mainContent.classList.add('hide')
        }
    }
}